export default __webpack_public_path__ + "static/char-v-01-161615af821490f7dd2658c91b36685b.webp";